<template>
  <div class="BatchEdit">
    <a-row type="flex" align="middle" style="margin-bottom:10px">
      <a-col :span="4">
        <span>Modification method</span>
      </a-col>
      <a-col :span="8">
        <a-radio-group v-model="editType" name="radioGroup">
          <a-radio :value="1">
            Item by item
          </a-radio>
          <a-radio :value="2">
            Batch
          </a-radio>
          <a-radio :value="3">
            Unified
          </a-radio>
        </a-radio-group>
      </a-col>
      <a-col :span="12" style="text-align:right">
        <a-button style="margin-right: 10px" @click="upperCase">One click initial capital</a-button>
        <span>
          <span style="color: #333">Language screening:</span>
          <a-dropdown :trigger="['click']">
            <a class="dropdown-a" @click="e => e.preventDefault()">
              {{ languageData[language] }} <a-icon class="down-icon" type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item :key="index" v-for="(item, index) in languageData" @click="languageFn(index)">
                {{ item }}
              </a-menu-item>
            </a-menu>
          </a-dropdown></span
        >
      </a-col>
    </a-row>
    <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" labelAlign="left">
      <a-form-item label="Modify name" v-if="editType === 3">
        <a-input
          :maxLength="200"
          @change="e => getValueName(e, 'sameName')"
          v-decorator="['nameSame', { rules: [{ required: true, message: 'Please enter a name' }] }]"
          allowClear
        />
      </a-form-item>
      <a-form-item label="Modify name" v-if="editType === 2">
        <!-- <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入文件名' }] }]" /> -->
        <a-textarea
          @change="e => getValueName(e, 'batchName')"
          v-decorator="['nameGroup', { rules: [{ required: true, message: 'Please enter a name' }] }]"
          allowClear
          style="height: 200px;"
        />
      </a-form-item>
      <div v-if="editType === 1">
        <a-form-item v-for="(value, index) in fileList" :key="index">
          <span slot="label">
            <a-popover placement="right" trigger="hover">
              <template slot="content">
                <img :src="value.img" width="240" height="240" />
              </template>
              <img :src="value.img" width="50" height="50" />
            </a-popover>
            <span>{{ languageData[language] }} Name</span>
          </span>
          <template v-for="(item, i) in languageData">
            <a-input
              v-if="+i === +language"
              :key="i"
              :maxLength="200"
              @change="e => setName(e, value)"
              v-decorator="[
                `name${language}${index}`,
                { rules: [{ required: false, message: 'Please enter a name' }], initialValue: getName(value) }
              ]"
              allowClear
            />
          </template>
          <div v-if="value.brands && value.brands[language] && value.brands[language].length" class="brands">
            <p class="title">Risk words:</p>
            <div class="brand" v-for="(value, index) in value.brands[language]" :key="index">
              <img src="@/assets/icons/lowLevel.png" width="24" height="24" title="At risk" v-if="value.level === 1" />
              <img src="@/assets/icons/mLevel.png" width="24" height="24" title="Medium risk" v-if="value.level === 2" />
              <img src="@/assets/icons/hLevel.png" width="24" height="24" title="High risk" v-if="value.level === 3" />
              <span>{{ value.name }}</span>
              <span>Remarks:{{ value.remark }}</span>
            </div>
          </div>
          <div v-if="value.risks && value.risks[language] && value.risks[language].length" class="risks">
            <p class="title">System risk word:</p>
            <div class="risk" v-for="(value, index) in value.risks[language]" :key="index">
              <img src="@/assets/icons/lowLevel.png" width="24" height="24" title="At risk" v-if="value.level === 1" />
              <img src="@/assets/icons/mLevel.png" width="24" height="24" title="Medium risk" v-if="value.level === 2" />
              <img src="@/assets/icons/hLevel.png" width="24" height="24" title="High risk" v-if="value.level === 3" />
              <span>{{ value.name }}</span>
              <span>Remarks:{{ value.remark }}</span>
            </div>
          </div>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import { languageData, languageKey } from '@/utils/const'
export default {
  name: 'BatchEdit',
  data() {
    return {
      editType: 1,
      language: 1,
      languageData: languageData,
      languageKey: languageKey,
      batchName: {},
      sameName: {},
      form: this.$form.createForm(this, { name: 'EditTextBatch' }),
      fileList: []
    }
  },
  methods: {
    getName(item) {
      if (item.material_name_alias) {
        return item.material_name_alias[this.language]
      } else {
        return ''
      }
    },
    setName(e, value) {
      value.material_name_alias[this.language] = e.target.value
    },
    languageFn(index) {
      if (this.language !== index) {
        this.language = index
        if (this.editType === 3) {
          this.form.setFieldsValue({
            nameSame: this.sameName[this.languageKey[this.language]] || ''
          })
        } else if (this.editType === 2) {
          this.form.setFieldsValue({
            nameGroup: this.batchName[this.languageKey[this.language]] || ''
          })
        }
      }
    },
    getValueName(e, key) {
      this[key][this.languageKey[this.language]] = e.target.value
    },
    upperCase() {
      // const values = this.form.getFieldsValue()
      const upperValues = {}
      if (this.editType === 3) {
        for (const it in this.sameName) {
          if (this.sameName[it]) {
            this.sameName[it] = this.sameName[it].replace(/^[a-z]|(\s)[a-z]/g, (e, r) => {
              return e.toUpperCase()
            })
          }
        }
        upperValues.nameSame = this.sameName[this.languageKey[this.language]] || ''
      } else if (this.editType === 2) {
        // const newStr = values.nameGroup.replace(/^[a-z]|(\n)(\s+)?[a-z]|(\s)[a-z]/g, (e, r) => {
        //   return e.toUpperCase()
        // })
        for (const it in this.batchName) {
          if (this.batchName[it]) {
            this.batchName[it] = this.batchName[it].replace(/^[a-z]|(\n)(\s+)?[a-z]|(\s)[a-z]/g, (e, r) => {
              return e.toUpperCase()
            })
          }
        }
        upperValues.nameGroup = this.batchName[this.languageKey[this.language]] || ''
      } else {
        // Object.keys(values).map(item => {
        //   const value = values[item]
        //   const newValue = value.replace(/^[a-z]|(\s)[a-z]/g, (e, r) => {
        //     return e.toUpperCase()
        //   })
        //   upperValues[item] = newValue
        // })
        this.fileList.forEach((item, index) => {
          for (const it in item.material_name_alias) {
            item.material_name_alias[it] = item.material_name_alias[it].replace(/^[a-z]|(\s)[a-z]/g, (e, r) => {
              return e.toUpperCase()
            })
          }
          upperValues[`name${this.language}${index}`] = item.material_name_alias[this.language]
        })
      }
      this.form.setFieldsValue(upperValues)
    }
  }
}
</script>

<style lang="less" scoped>
.brands,
.risks {
  width: 50%;
  > .title {
    line-height: 16px;
    margin: 0;
  }
  .brand,
  .risk {
    img {
      margin-right: 10px;
    }
    span {
      margin-right: 10px;
    }
  }
}
</style>
